import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Table } from 'primeng/table';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Usuario } from 'src/app/admihair/api/dto/usuario';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UsuarioPermissaoEmpresaService } from 'src/app/admihair/service/usuario-permissao-empresa.service';
import { UsuarioService } from 'src/app/admihair/service/usuario.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { AdmihairBaseComponent } from '../../../admihair-base.component';

@Component({
  selector: 'app-usuario-empresa-listar',
  templateUrl: './usuario-empresa-listar.component.html',
  styleUrls: ['./usuario-empresa-listar.component.scss']
})
export class UsuarioEmpresaListarComponent extends AdmihairBaseComponent implements OnInit {

  @ViewChild('filter') filter!: ElementRef;
  loading: boolean = false;
  loadingUsuarios: boolean = false;
  empresaSelecionada?: Empresa;
  usuarios: Usuario[] = [];

  constructor(private usuarioEmpresaService: UsuarioService,
    private usuarioPermissaoEmpresaService: UsuarioPermissaoEmpresaService,
    private confirmationService: ConfirmationService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    erroService: ErroService,
    utilStorageService: UtilStorageService) {
    super(erroService, utilStorageService)
  }


  ngOnInit(): void {
    this.loadingUsuarios = true;
    this.verificarPermissoes();
    this.empresaSelecionada = this.getEmpresa();
    if (this.permissaoListar) {
      this.carregarUsuarios();
    }
  }


  carregarUsuarios() {
    this.usuarioEmpresaService.listarPorEmpresaId(this.empresaSelecionada?.id).subscribe({
      next: (data: Usuario[]) => {
        this.loadingUsuarios = false;
        this.usuarios = data;
      },
      error: (err: any) => {
        this.exibirMensagemErro(err);
      }
    })
  }

  excluir(usuarioId: number) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja excluir o vínculo do usuário?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.usuarioPermissaoEmpresaService.excluirVinculoUsuario(usuarioId, this.empresaSelecionada?.id).subscribe({
          next: () => {
            this.exibirMensagemSucesso();
            this.carregarUsuarios();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        });
      }
    });
  }

  editar(id?: number) {
    this._router.navigate(["/apps/usuario-empresa/editar/" + id], { relativeTo: this._activatedRoute })
  }

  detalhar(id?: number) {
    this._router.navigate(["/apps/usuario-empresa/detalhar/" + id], { relativeTo: this._activatedRoute })
  }


  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  verificarPermissoes() {
    this.permissaoListar = AuthUtil.verificarPermissao('PERM_LISTAR_USUARIO_EMPRESA');
    this.permissaoInserir = AuthUtil.verificarPermissao('PERM_INSERIR_USUARIO_EMPRESA');
    this.permissaoEditar = AuthUtil.verificarPermissao('PERM_EDITAR_USUARIO_EMPRESA');
    this.permissaoExcluir = AuthUtil.verificarPermissao('PERM_EXCLUIR_USUARIO_EMPRESA');
  }

}
